import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"

const state = {
  currentModule: "",
  loader: false,
  drawerOpen: true,
  alert: {
    message: "",
    type: null,
    show: false,
    code: null,
    extras: null,
  },
  axiosHideLoader: false,
  togglePushNotification: true,
  newVersionSnackbar: false,
  routeCount: 0,
  versionCheck: false,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
